export enum MessageUiComponentStatus {
  Pending = "pending",
  Approved = "approved",
  Denied = "denied",
  Expired = "expired",
}
